import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Works.css";

const workCategories = [
  {
    id: "logo",
    title: "Branding",
    path: "/works/logos",
    icon: (
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M2 17L12 22L22 17" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M2 12L12 17L22 12" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
  },
  {
    id: "posters",
    title: "Posters",
    path: "/works/posters",
    icon: (
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="3" width="16" height="18" rx="2" stroke="white" strokeWidth="1.2" strokeLinecap="round"/>
        <path d="M4 17L9 12L14 17L20 11" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="12" cy="10" r="2.5" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
  },
  {
    id: "videos",
    title: "Video Edits",
    path: "/works/videos",
    icon: (
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 12L10 15V9L15 12Z" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        <rect x="2" y="4" width="20" height="16" rx="2" stroke="white" strokeWidth="1.2" strokeLinecap="round"/>
      </svg>
    )
  }
];

const CategoryCard = ({ category, index }) => {
  const cardRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) entry.target.classList.add("work-cat-visible"); },
      { threshold: 0.1 }
    );
    if (cardRef.current) observer.observe(cardRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <Link to={category.path} className="work-cat-card" ref={cardRef} style={{ "--delay": `${index * 0.1}s` }}>
      <div className="work-cat-icon">
        {category.icon}
      </div>
      <h3 className="work-cat-title">{category.title}</h3>
    </Link>
  );
};

const Works = () => {
  const headerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) entry.target.classList.add("works-header--visible"); },
      { threshold: 0.2 }
    );
    if (headerRef.current) observer.observe(headerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="works-section" id="Works">
      <div className="works-noise" />
      <div className="works-grid-bg" />

      <div className="works-inner" style={{ paddingTop: '80px' }}>
        <div className="works-header" ref={headerRef}>
          <div className="works-header-left">
            <h2 className="works-heading">
            <span className="works-heading-accent">DESIGNS</span>
            </h2>
          </div>
        </div>

        <div className="works-cat-grid">
          {workCategories.map((cat, idx) => (
            <CategoryCard key={cat.id} category={cat} index={idx} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Works;